

(function($, App, Utils, Components){
  'use strict';

  const logger = new Logger("SidebarNav");

  Components.create('SidebarNav', {

    Selectors: {
      Main: ".sidebar-menu",
      Toggler: '.sidebar-toggle'
    },


    bindEvents: function() {


      if ( Utils.Responsive.isXS()  || Utils.Responsive.isSM() ) {

        var active = $(Components.SidebarNav.Selectors.Main).find('a.is-active').html();
        var activeClass = $(Components.SidebarNav.Selectors.Main).find('a.is-active').attr('class');
        $('.sidebar-toggle').html(active).addClass(activeClass);

      }


      Utils.Responsive.on(Utils.Responsive.Events.ResolutionEnter, function(e, res) {

        if (res && res.label == 'xs' || res && res.label == 'sm' ) {
          var active = $(Components.SidebarNav.Selectors.Main).find('a.is-active').html();
          var activeClass = $(Components.SidebarNav.Selectors.Main).find('a.is-active').attr('class');
          $('.sidebar-toggle').html(active).addClass(activeClass);
        }

      });

    },

   init: function() {
      if ( $(Components.SidebarNav.Selectors.Main).length ) {
        Components.SidebarNav.bindEvents();
      }
    }

  });

})(jQuery,
  window.App,
  window.App.Utils,
  window.App.Components
);
